<template>
    <vue-dropzone
            v-if="fileUrl"
            :id="id"
            ref="dropzone"
            :options="dropOptions"
            @vdropzone-sending="onFileSending"
            @vdropzone-success-multiple="onFileSuccess"
            @vdropzone-error="onFileError"
    >
    </vue-dropzone>
</template>

<script>
import FileDropMixin from '@/components/Form/FileDropMixin';
import { forEach } from 'lodash';

export default {
  name: 'File-Drop',
  props: {
    fileUrl: {
      default: null,
    },
    options: {
      type: Object,
    },
    id: {
      default: 'fileDrop',
    },
    compRef: {
      default: 'dropzone',
    },
    additionalParams: {
      default: Object,
      required: false,
    },
    hideErrors: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    options(newOptions) {
      if (newOptions) {
        this.dropOptions = {
          ...this.dropOptions,
          ...newOptions,
        };
      }
    },
  },
  mixins: [FileDropMixin],
  methods: {
    getRef() {
      return this.id + '-dropzone';
    },
    onFileSending(file, xhr, formData) {
      this.attachParams(file, xhr, formData);
    },
    attachParams(file, xhr, formData) {
      if (this.additionalParams) {
        forEach(this.additionalParams, (param, key) => {
          if (param.value !== null) {
            formData.append(key, param.value);
          }
        });
      }
    },
    processFiles() {
      this.loading = true;
      this.$refs.dropzone.processQueue();
    },
    onFileSuccess(file, response) {
      this.$emit('onFileSuccess');
      return this.complete();
    },
    onFileError(file, errorMessage) {
      this.$emit('onFileError');


      this.$refs.dropzone.removeFile(file);
      if (!this.hideErrors) {
        const text = this.formatErrorMessage(errorMessage);
        this.$notify({
          title: 'Error',
          text,
          type: 'error',
        });
      }
      this.complete();
    },
  },
};
</script>
